import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { filter } from 'rxjs';

import { CmsService } from '@spartacus/core';

import { CheckoutStepsEnum } from '@seb/web-design-system/checkout';
import { CHECKOUT_STEPS } from '@seb/web-common/core/models';

@Injectable({
  providedIn: 'root'
})
export class CheckoutStepperService {
  private readonly router = inject(Router);
  private readonly cmsService = inject(CmsService);

  private step: CheckoutStepsEnum = CheckoutStepsEnum.overview;

  constructor() {
    this.cmsService
      .getCurrentPage()
      .pipe(filter((p) => !!p))
      .subscribe((page) => this.step = this.getStepFromUrl(page.label));
  }

  private getPreviousStep(current: CheckoutStepsEnum, currentUrl: string): string | undefined {
    if (current === CheckoutStepsEnum.recap && currentUrl.includes('/checkout/express/review')) {
      return CHECKOUT_STEPS.find((step) => step.enum === CheckoutStepsEnum.overview)?.url ?? '/';
    }

    const currentStep = CHECKOUT_STEPS.find((checkoutStep) => checkoutStep.enum === current);

    if (!currentStep) return '/';

    const previousStep = CHECKOUT_STEPS.find((checkoutStep) => checkoutStep.enum === currentStep.enum - 1);

    return previousStep?.url ?? '/';
  }

  getStepFromUrl(url: string): CheckoutStepsEnum {
    const step = CHECKOUT_STEPS.find((checkoutStep) =>
      checkoutStep.url === url || checkoutStep.additionalUrls?.includes(url)
    );

    return step?.enum ?? CheckoutStepsEnum.overview;
  }

  goBack(): void {
    const currentUrl = this.router.url;
    const previousUrl = this.getPreviousStep(this.step, currentUrl);

    this.router.navigateByUrl(previousUrl);
  }
}
